import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceProjectCreationNotificationState = createStateReducer(
  initialState,
  {
    [events.createProjectSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createProject",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.createProjectFailed]: (state, { error: { message } }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createProject",
          flags: ["failure"],
          args: { failure: "true", message },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceProjectCreationNotificationState };
